import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import WhatsappContent from 'components/common/WhatsappContent/WhatsappContent';
import useGlobalStyles from 'styles/globalStyles';

export default function WhatsappPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'Whatsapp'}
            buttons={[]}
          />
        </Box>

        <Box mt={3}>
          <WhatsappContent />
        </Box>
      </Container>
    </Box>
  )
}

